import * as u from "react";
function f(t, o, n) {
  var r = u.useState(o), e = r[0], c = r[1];
  return u.useEffect(function() {
    if (!e && window && t.current) {
      var i = window.getComputedStyle(t.current).direction;
      i && c(i);
    }
  }, n), e;
}
export {
  f as u
};
